import { TableCard } from '../../../../components'
import { FaturaResponsavelListHeader } from './components/header/FaturaResponsavelListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FaturaResponsavelTable } from './table/FaturaResponsavelTable'

const FaturaResponsavelList = () => {
  return (
    <TableCard>
      <FaturaResponsavelListHeader />
      <FaturaResponsavelTable />
    </TableCard>
  )
}

// Filtros por fora: a busca usa a instituição selecionada (vai na URL do endpoint).
export const FaturaResponsavelListWrapper = () => (
  <ListFiltersProvider>
    <QueryRequestProvider>
      <QueryResponseProvider>
        <FaturaResponsavelList />
      </QueryResponseProvider>
    </QueryRequestProvider>
  </ListFiltersProvider>
)
